import { JSONApiDataObject } from './types';

export enum BsdirResourceType {
  GROUP = 'bsdirGroup',
  PAGE = 'bsdirPage',
  LOCATION_PAGE = 'landingPageData'
}

export interface BsdirPageBaseAttributes {
  slug: string;
  title: string;
  pageH1: string;
  pageH2: string;
  pageH4: string;
  metaTitle: string;
  metaDescription: string;
  optOutOfHreflang: boolean;
  testPage: boolean;
  heroImageUrl: string | null;
  isOneCategory: boolean;
  // Null when neither the page nor its category landing settings set one
  embeddedFormTitle: string | null;
  scheme: string | null;
  schemePriceRange: string | null;
  pricingTitle: string;
  bestProfessionalTitle: string | null;
  jobEvaluationsTitle: string | null;
  faqTitle: string | null;
  extraDataTitle: string | null;
  showCalculateCostSection: boolean;
  youtubeVideoId: string | null;
  youtubeVideoTitle: string | null;
  rating: number | null;
  feedbacksNum: number | null;
}

export type BsdirGroup = BsdirPageBaseAttributes;

export interface BsdirPage extends BsdirPageBaseAttributes {
  groupSlug: string;
  groupTitle: string;
}

export interface BsdirLocationPage {
  title: string;
  groupSlug: string;
  // 'l' for group-level location pages
  pageSlug: string;
  locationSlug: string;
}

export interface BsdirCategory {
  title: string;
  slug: string;
  isProfileCardsClickable: boolean;
}

export interface BsdirFaqItem {
  title: string | null;
  text: string;
  order: number;
  // FAQPage JSON-LD position; null when the item is excluded from the schema
  position: number | null;
}

export interface BsdirTopPro {
  username: string;
  fullName: string;
  mugshot: string;
  snippet: string;
  rating: number;
  reviewsCount: number;
  totalJobsCount: number;
  galleryItemsCount: number;
  isNewPro: boolean;
  isTopPro: boolean;
  location: string | null;
}

export interface BsdirFeedback {
  buyerMaskedName: string;
  reviewedSeller: string;
  comment: string | null;
  // DRF serializes this DecimalField as a string, e.g. "4.5"
  rating: string | null;
  date: string;
}

export interface BsdirPricing {
  priceMin: number;
  priceMax: number;
  numberOfConcludedJobs: number;
}

export interface BsdirSubCategoryPricing {
  subCategoryTitle: string;
  priceMin: number;
}

export interface BsdirGallery {
  title: string | null;
}

export interface BsdirGalleryItem {
  image: string | null;
  youtubeVideoId: string | null;
  title: string | null;
  description: string | null;
  altText: string;
  order: number;
}

export interface BsdirRelatedService {
  title: string;
  path: string | null;
}

export interface BsdirConcludedJobAttributeValue {
  label: string;
  icon: string | null;
  value: string;
}

export interface BsdirConcludedJob {
  title: string;
  price: number | null;
  proName: string | null;
  location: string | null;
  dateConcluded: string | null;
  attributeValues: Array<BsdirConcludedJobAttributeValue>;
}

export interface BsdirPageLink {
  slug: string;
  title: string;
  path: string;
}

export interface BsdirResolution {
  // filter[path] without surrounding slashes
  path: string;
  resource?: JSONApiDataObject<BsdirGroup | BsdirPage | BsdirLocationPage>;
  notFound: boolean;
}
